import React from 'react';
import { BsBuilding } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditListingsSmc = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsBuilding',
				label: 'building',
				component: BsBuilding,
			}}
			defaultTheme="blue"
			widgetType="listingsSmc"
		/>
	);
};

export default EditListingsSmc;
